import { ReactNode } from "react";
import { Stack, StackProps } from "@kaltura/mediaspace-shared-styled";
import styled from "@emotion/styled";

export interface RowContainerProps extends StackProps {
    icon: ReactNode;
    children: ReactNode;
}

/**
 * Generic container for an asset row - just an icon and the row body.
 */
export const RowContainer = ({ icon, children, ...props }: RowContainerProps) => {
    return (
        <StyledContainer direction={"row"} gap={2} alignItems={"center"} {...props}>
            <StyledIconContainer>{icon}</StyledIconContainer>

            {children}
        </StyledContainer>
    );
};

const StyledContainer = styled(Stack)(({ theme }) => ({
    border: `1px solid ${theme.kaltura.palette.tone4}`,
    borderRadius: theme.kaltura.shape.roundness2,
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1, 2),
    },
}));

const StyledIconContainer = styled("div")(({ theme }) => ({
    position: "relative",
    width: 40,
    height: 40,
    // icon
    "> *": {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        color: theme.kaltura.palette.primary.main,
    },
}));
